/**
 * Shared SummaryCard primitive.
 *
 * Ported from aieweb/components/ui/summary-card.tsx. Two optional props:
 * `comparisonLabel` (rendered as muted text in parens after the primary value)
 * and `tooltipText` (rendered via the native `title` attribute on the card
 * root — there is no tooltip primitive in `components/ui/`).
 */
import { Card, CardContent } from "@/components/ui/card";

export interface SummaryCardProps {
  label: string;
  value: string | number;
  /** Small muted text rendered in parens after `value`. e.g. "8 prior". */
  comparisonLabel?: string;
  /** Rendered as `title` attribute on the card root for hover disclosure. */
  tooltipText?: string;
}

export function SummaryCard({
  label,
  value,
  comparisonLabel,
  tooltipText,
}: SummaryCardProps) {
  return (
    <Card
      className="border border-border"
      title={tooltipText}
    >
      <CardContent className="pt-6">
        <p className="text-xs text-muted-foreground">{label}</p>
        <p className="text-2xl font-bold mt-1 text-foreground">
          {value}
          {comparisonLabel ? (
            <span className="ml-2 text-xs font-normal text-muted-foreground">
              ({comparisonLabel})
            </span>
          ) : null}
        </p>
      </CardContent>
    </Card>
  );
}
